var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.classId)?_c('liveroom-module',{attrs:{"class-id":_vm.classId,"sub-id":_vm.subId,"is-replay":_vm.isReplay},on:{"live-info":_vm.getLiveInfo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }